import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'
import { TemplateService } from '../services/template.service'
import { GlobalErrorService } from '@services/global-error.service'

export function templateExistsValidator(
  templateService: TemplateService,
  globalErrorService: GlobalErrorService,
  initialValue: string | null = null,
  debounceTimeMs?: number
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value as unknown

    if (typeof value !== 'string' || value.trim() === '') {
      return of(null)
    }

    const titleToCheck = value.trim()

    if (initialValue !== null && titleToCheck === initialValue.trim()) {
      return of(null)
    }

    return timer(debounceTimeMs ?? 300).pipe(
      switchMap(() => templateService.checkTemplateExists(titleToCheck)),
      map(exists => (exists ? { templateExists: true } : null)),
      catchError(() => {
        globalErrorService.reportError({
          subsystemName: 'Template Title Validator',
          description: 'Could not validate if template title exists. Please try again.'
        })
        return of(null)
      }),
      first()
    )
  }
}
